var map = {
	"./Admin/Login": 54887,
	"./Admin/Login.vue": 54887,
	"./Admin/Logs": 71558,
	"./Admin/Logs.vue": 71558,
	"./AdvertisementDashboard/Dashboard": 3019,
	"./AdvertisementDashboard/Dashboard.vue": 3019,
	"./Campaigns/SimpleCampaigns": 54948,
	"./Campaigns/SimpleCampaigns.vue": 54948,
	"./Campaigns/SimpleCampaigns_old": 92580,
	"./Campaigns/SimpleCampaigns_old.vue": 92580,
	"./Campaigns/SimpleCampaigns_old_vs_prod": 37293,
	"./Campaigns/SimpleCampaigns_old_vs_prod.vue": 37293,
	"./Dashboard": 9828,
	"./Dashboard.vue": 9828,
	"./Dev/FlexibleTemplatePreview": 59202,
	"./Dev/FlexibleTemplatePreview.vue": 59202,
	"./Error": 75078,
	"./Error.vue": 75078,
	"./Financial/BranchDetails": 89381,
	"./Financial/BranchDetails.vue": 89381,
	"./Financial/CheckingAccount": 54309,
	"./Financial/CheckingAccount.vue": 54309,
	"./Financial/Rappel": 60558,
	"./Financial/Rappel.vue": 60558,
	"./ForgotPassword": 26234,
	"./ForgotPassword.vue": 26234,
	"./Login": 92834,
	"./Login.vue": 92834,
	"./Orders/AffinityOrder": 84206,
	"./Orders/AffinityOrder.vue": 84206,
	"./Orders/AwaitingPayment": 10212,
	"./Orders/AwaitingPayment.vue": 10212,
	"./Orders/ExpressOrder": 18302,
	"./Orders/ExpressOrder.vue": 18302,
	"./Orders/History": 14364,
	"./Orders/History.vue": 14364,
	"./Orders/NormalOrder": 83022,
	"./Orders/NormalOrder.vue": 83022,
	"./Orders/NormalOrderCart": 70491,
	"./Orders/NormalOrderCart.vue": 70491,
	"./Orders/NormalOrderSummary": 18643,
	"./Orders/NormalOrderSummary.vue": 18643,
	"./Orders/PendingCarts": 1265,
	"./Orders/PendingCarts.vue": 1265,
	"./Orders/PendingProducts": 91166,
	"./Orders/PendingProducts.vue": 91166,
	"./PreRegistrationSent": 30573,
	"./PreRegistrationSent.vue": 30573,
	"./PresentationVideo": 70713,
	"./PresentationVideo.vue": 70713,
	"./Products/Simposium": 33280,
	"./Products/Simposium.vue": 33280,
	"./ProfilesManagement/Profiles": 10227,
	"./ProfilesManagement/Profiles.vue": 10227,
	"./Register": 98394,
	"./Register.vue": 98394,
	"./ResetPassword": 19686,
	"./ResetPassword.vue": 19686,
	"./Statistics/Consumptions": 67278,
	"./Statistics/Consumptions copy": 86392,
	"./Statistics/Consumptions copy.vue": 86392,
	"./Statistics/Consumptions.vue": 67278,
	"./Statistics/Consumptions_old": 9667,
	"./Statistics/Consumptions_old.vue": 9667,
	"./Statistics/MonthlyPurchases": 78700,
	"./Statistics/MonthlyPurchases.vue": 78700,
	"./Statistics/TopPurchases": 48374,
	"./Statistics/TopPurchases.vue": 48374,
	"./Tutorials": 74531,
	"./Tutorials.vue": 74531,
	"./VerifyBlockedUser": 4412,
	"./VerifyBlockedUser.vue": 4412,
	"./VerifyEmail": 23192,
	"./VerifyEmail.vue": 23192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88846;